import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Input, Button, Select, Form, Space, Row, Col } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { formItemLayout, tailLayout } from '../../js/globalParam'
import _ from 'lodash'

const { Option } = Select

export default function PositionsEdit() {

    const { id }: { id: string | undefined } = useParams()
    const [form] = useForm()

    const [pageTitle, setPageTitle] = useState<string>('')

    const [jsOptions, setJsOption] = useState<any[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/global/role_list').then((res: any) => {
            if (res) {
                setJsOption(res)

            } else {
                setJsOption([])
            }
        })

        if (id) {
            baseAxiosNoInfo('/manpower_center/position/detail', { params: { id } }).then((res: any) => {
                if (res) {
                    form.setFieldsValue({
                        position_name: res.position_name,
                        role_id: res.role_id,
                        position_number: res.position_number
                    })
                }
            })

            setPageTitle('编辑职位')

        } else {
            setPageTitle('新增职位')
        }
    }, [])

    const onFinish = (values: any) => {
        let url = id ? '/manpower_center/position/update' : '/manpower_center/position/add'

        axiosHandleEvent.post(url, {
            id,
            role_id: values.role_id,
            position_name: values.position_name,
            position_number: values.position_number
        })
    }

    return (<div className="common-level2-edit">
        {/* 人力中心 -> 组织架构 -> 职位管理  -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish}>
                <Form.Item label="职位名称" name="position_name" rules={[{ required: true, message: '输入职位名称' }]} >
                    <Input style={{ width: 320 }} />
                </Form.Item>

                <Form.Item label="职位角色" name="role_id" rules={[{ required: true, message: '选择绑定角色' }]}>
                    <Select style={{ width: 320 }} showSearch allowClear filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                        {jsOptions.map((el: any) => <Option value={el.role_id} key={el.role_id}>{el.role_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="职位编号" name="position_number" rules={[{ required: true, message: '输入职位编号' }]} >
                    <Input type="number" style={{ width: 320 }} />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    </div>)
}